import { Ok } from "@megaron/result";

import { Serializer } from "../serializer";
import { getSerializerSchema } from "../serializerSchema";

export const nullable = <T>(serializer: Serializer<T>): Serializer<T | null> => ({
  ...serializer,
  schema: { kind: "nullable", inner: getSerializerSchema(serializer), emptyStrAsNull: false },
  serialize: (value) => {
    if (value === null) return value;
    return serializer.serialize(value);
  },
  deserialize: (raw) => {
    if (raw === null) return Ok(raw);
    return serializer.deserialize(raw);
  },
});
